export const ADD_BUTTON_SIZE = 30 // px

export const NODE_WIDTH = 268 // min px
export const NODE_HEIGHT = 142 // min px

export default ADD_BUTTON_SIZE
